<template>
  <el-dialog title="设备配置管理" :visible.sync="dialogVisible" width="750px" @open="loadData" class="config-dialog" :append-to-body="true">
    <div style="margin-bottom: 12px;">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增</el-button>
    </div>
    <el-table :data="pageData" v-loading="loading" size="small" border stripe>
      <el-table-column prop="assetNo" label="监测设备出厂序号" min-width="140" />
      <el-table-column prop="manufacturer" label="断路器厂家名称" min-width="120" />
      <el-table-column prop="cbmName" label="断路器产品型号" min-width="120" />
      <el-table-column prop="ommName" label="操作机构型号" min-width="120" />
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" style="color: #F56C6C;" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="configList.length"
        :page-size="pageSize"
        :current-page.sync="currentPage"
      />
    </div>

    <el-dialog :title="editMode ? '编辑设备配置' : '新增设备配置'" :visible.sync="editVisible" width="480px" append-to-body>
      <el-form :model="editForm" label-width="140px" size="small" :rules="rules" ref="editForm">
        <el-form-item label="出厂序号" prop="assetNo">
          <el-input v-model="editForm.assetNo" :disabled="editMode" placeholder="请输入监测设备出厂序号" />
        </el-form-item>
        <el-form-item label="断路器厂家名称" prop="manufacturer">
          <el-input v-model="editForm.manufacturer" placeholder="请输入厂家名称" />
        </el-form-item>
        <el-form-item label="断路器产品型号" prop="cbmName">
          <el-input v-model="editForm.cbmName" placeholder="请输入断路器产品型号" />
        </el-form-item>
        <el-form-item label="操作机构型号" prop="ommName">
          <el-input v-model="editForm.ommName" placeholder="请输入操作机构型号" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>

    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'

const API_BASE = '/mqtt'

export default {
  name: 'ConfigManagement',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      configList: [],
      currentPage: 1,
      pageSize: 5,
      editVisible: false,
      editMode: false,
      saving: false,
      editForm: {
        assetNo: '',
        manufacturer: '',
        cbmName: '',
        ommName: ''
      },
      rules: {
        assetNo: [{ required: true, message: '请输入监测设备出厂序号', trigger: 'blur' }]
      }
    }
  },
  computed: {
    pageData() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.configList.slice(start, start + this.pageSize)
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await axios.get(`${API_BASE}/config/list`)
        if (res.data.code === 200) {
          this.configList = res.data.data || []
        }
      } catch (e) {
        console.error('加载配置失败:', e)
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.editMode = false
      this.editForm = { assetNo: '', manufacturer: '', cbmName: '', ommName: '' }
      this.editVisible = true
      this.$nextTick(() => { this.$refs.editForm && this.$refs.editForm.clearValidate() })
    },
    handleEdit(row) {
      this.editMode = true
      this.editForm = { assetNo: row.assetNo, manufacturer: row.manufacturer, cbmName: row.cbmName, ommName: row.ommName }
      this.editVisible = true
      this.$nextTick(() => { this.$refs.editForm && this.$refs.editForm.clearValidate() })
    },
    async handleSave() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return
        if (!this.editMode) {
          const exists = this.configList.some(c => c.assetNo === this.editForm.assetNo)
          if (exists) {
            this.$message.warning('出厂序号已存在!')
            return
          }
        }
        this.saving = true
        try {
          const res = await axios.post(`${API_BASE}/config/save`, this.editForm)
          if (res.data.code === 200) {
            this.$message.success('保存成功')
            this.editVisible = false
            this.loadData()
          } else {
            this.$message.error(res.data.message)
          }
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.saving = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确定删除 "${row.assetNo}" 的配置吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await axios.delete(`${API_BASE}/config/${row.assetNo}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadData()
          }
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.pagination-bar {
  margin-top: 12px;
  text-align: right;
}
</style>
